import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  OnboardingProgressModuleKey,
  OnboardingProgressModuleView,
  OnboardingProgressService,
} from 'src/app/shared/service/onboarding-progress/onboarding-progress.service';

export interface OnboardingProgressDialogData {
  imo: string;
}

export type OnboardingProgressDialogResult =
  | { action: 'process'; module: OnboardingProgressModuleKey }
  | { action: 'all_complete' }
  | { action: 'dismiss' };

@Component({
  selector: 'app-onboarding-progress-popup',
  templateUrl: './onboarding-progress-popup.component.html',
  styleUrls: ['./onboarding-progress-popup.component.scss'],
})
export class OnboardingProgressPopupComponent {
  modules: OnboardingProgressModuleView[] = [];
  allCompleted = false;
  vesselName = '';

  constructor(
    private dialogRef: MatDialogRef<
      OnboardingProgressPopupComponent,
      OnboardingProgressDialogResult
    >,
    private onboardingProgressService: OnboardingProgressService,
    @Inject(MAT_DIALOG_DATA) public data: OnboardingProgressDialogData,
  ) {
    this.refreshState();
  }

  refreshState(): void {
    const session = this.onboardingProgressService.getSession(this.data.imo);
    this.vesselName = session?.vessel_name || '';
    this.modules = this.onboardingProgressService.getModuleViews(this.data.imo);
    this.allCompleted = this.onboardingProgressService.isAllCompleted(
      this.data.imo,
    );
  }

  processModule(module: OnboardingProgressModuleKey): void {
    this.dialogRef.close({ action: 'process', module });
  }

  finish(): void {
    this.dialogRef.close({ action: 'all_complete' });
  }

  dismiss(): void {
    this.dialogRef.close({ action: 'dismiss' });
  }
}
